import request from '../functions/request'
/* ====== 权益充值 ==== */
export interface IRechargeProductItem {
    /**
     * 商品编码
     */
    proCode: string
  
    /**
     * 商品名称
     */
    proName: string
  
    /**
     * 列表图
     */
    listViewUrl: string
  
    /**
     * 1 现金 2积分 3 权益免费使用
     */
    exchangeType: number
  
    /**
     * 兑换价格（现金）
     */
    exchangePrice: number
  
    /**
     * 兑换价格（积分）
     */
    pointPrice: number
  }
  
  // 获取充值模版
  export function getRechargeProducts(params: {
    tenantCode: string
    equityCouponCode: string
  }) {
    return request<IRechargeProductItem[]>({
      uri: '/api/business/product/equity/recharge/products',
      params,
      method: 'GET',
      options: {
        hasLoading: false,
      }
    })
  }
  
  export interface IRechardRecordItem {
    id: number
  
    /**
     * 权益数量
     */
    equityNum: number
  
    /**
     * 可用权益数量
     */
    availableEquityNum: number
  
    /**
     * 权益渠道 1人工发送
     */
    channel: number
  
    /**
     * 权益渠道 1人工发送
     */
    channelName: string
  
    /**
     * 权益状态 0待使用 1已使用(作废了) 2.冻结 3.已过期
     */
    equityStatus: number
  
    /**
     * 权益状态 0待使用 1已使用(作废了) 2.冻结 3.已过期
     */
    equityStatusName: string
  
    /**
     * 第3方关联编码
     */
    thirdCode: string
  
    /**
     * 权益有效期开始
     */
    equityExpirationStart: string
  
    /**
     * 权益有效期结束
     */
    equityExpirationEnd: string
  }
  
  // 获取充值明细
  export function getRechargeRecord(params: {
    tenantCode: string
    equityCouponCode: string
  }) {
    return request<IRechardRecordItem[]>({
      uri: '/api/business/product/equity/recharge/records',
      params,
      method: 'GET',
    })
  }

  // 获取权益跳转地址
  export function getEquityRedirectUrl(params: {
    categoryType?: string
    equityCouponCode: string
  }) {
    return request<string>({
      uri: '/api/business/member/equity/getEquityRedirectUrl',
      params,
      method: 'POST',
    })
  }